// extracted by mini-css-extract-plugin
export default {"component":"RightElement_component__H75OP","firstText":"RightElement_firstText__5C6WR"};